/*
 * Public API Surface of comunications
 */
export * from './lib/comunications.module';
